import { WORK_MODULES, setStoredWorkModule } from "@/modules/workModuleCore";

export const ACCESS_CONTEXT_SELECTION_PATH = "/seleccionar-contexto";

export const CONTEXT_TYPE_OWNER = "owner";
export const CONTEXT_TYPE_AUXILIARY = "auxiliary";

/** ¿Debe elegir contexto antes de operar? */
export function requiresAccessContextSelection(user = null) {
  return Boolean(user?.requires_context_selection);
}

/** ¿Tiene más de un contexto (puede cambiar sin cerrar sesión)? */
export function hasMultipleAccessContexts(user = null) {
  const items = user?.access_contexts;
  return Array.isArray(items) && items.length > 1;
}

/** Ajusta módulo activo al resolver contexto o login (evita arrastrar vf:active_work_module de otra sesión en el mismo navegador). */
export function applyWorkModuleForAccessContext(_user = null) {
  setStoredWorkModule(WORK_MODULES.VISOR_SAT);
}

/** Ruta destino tras elegir contexto o sesión ya resuelta. */
export function resolvePathAfterAccessContext(user = null) {
  if (!user) return "/login";
  return "/";
}
